import { render, staticRenderFns } from "./ColunasSelecionada.vue?vue&type=template&id=40f31108&scoped=true"
import script from "./ColunasSelecionada.vue?vue&type=script&lang=js"
export * from "./ColunasSelecionada.vue?vue&type=script&lang=js"
import style0 from "./ColunasSelecionada.vue?vue&type=style&index=0&id=40f31108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f31108",
  null
  
)

export default component.exports